import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import HttpApis from "../../services/HttpApis";
import '../ProfileScreen/style.css';
import truncateProfileName from '../Truncation';
import Loader from '../loader/Loader';

export default function ProfileScreen() {
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [avatars, setAvatars] = useState([]);
  const [isSelecting, setIsSelecting] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const isActivateCodeRoute = location.state?.isActivateCodeRoute || false;
  const isSwitchingProfile = location.state?.isSwitchingProfile || false;
  const token = useSelector((state) => state.authReducer?.token);

  useEffect(() => {
    const currentAvatarId = localStorage.getItem('selectedAvatar');
    if (currentAvatarId) {
      setSelectedAvatar(parseInt(currentAvatarId));
    }
  }, []);

  useEffect(() => {
    if (!token) return;
    const fetchAvatars = async () => {
      try {
        setLoading(true);
        const response = await HttpApis.getAllProfile();

        if (response.data && response.data.data && response.data.data.length > 0) {
          setAvatars(response.data.data);
        } else {
          navigate("/login", { replace: true });
        }
      } catch (error) {
        console.error("Error fetching avatars:", error);
        navigate("/login", { replace: true });
      } finally {
        setLoading(false);
      }
    };
    fetchAvatars();
  }, [token, navigate]);

  useEffect(() => {
    const handlePopState = (e) => {
      e.preventDefault();
      window.history.pushState(null, '', window.location.pathname);
    };

    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleAvatarClick = async (avatarId) => {
    if (isSelecting) return;

    setSelectedAvatar(avatarId);
    setIsSelecting(true);

    try {
      await HttpApis.postSetProfile(avatarId);
      const selectedAvatarData = avatars.find(avatar => avatar.id === avatarId);
      localStorage.setItem('selectedAvatar', avatarId);
      localStorage.setItem('selectedProfileName', selectedAvatarData?.name || 'User');
      localStorage.setItem('profileSelected', 'true');
      const redirectTo = localStorage.getItem("postLoginRedirect");
      localStorage.removeItem("postLoginRedirect");
      navigate(redirectTo || "/home", { replace: true });
    } catch (error) {
      console.error("Error setting profile:", error);
      alert("Failed to set profile. Please try again.");
      setIsSelecting(false);
    }
  };

  const handleAddProfile = () => {
    navigate("/CreateProfile");
  };

  const handleProfile = () => {
    navigate("/editProfile");
  };
  if (loading) return <Loader />;

  return (
    <div className="profile-container">
      <div className="profile-content">
        <h1 className="profile-title">Who's watching?</h1>

        <div className="avatar-container">
          {avatars.map((avatar) => (
            <div key={avatar.id} className="avatar-wrapper">
              <button
                onClick={() => handleAvatarClick(avatar.id)}
                className={`avatar-button ${isSwitchingProfile && selectedAvatar === avatar.id ? 'selected' : ''}`}
                disabled={isSelecting}
              >
                <img
                  src={avatar.image_url || avatar.avatar_img}
                  alt={avatar.name || `Avatar ${avatar.id}`}
                  className="avatar-image"
                />
              </button>
              <p className="avatar-name">{truncateProfileName(avatar.name || 'User')}</p>
            </div>
          ))}

          {avatars.length < 5 && (
            <div className="avatar-wrapper">
              <button
                onClick={handleAddProfile}
                className="avatar-button add-profile-button"
              >
                <div className="add-icon">+</div>
              </button>
              <p className="avatar-name">Add Profile</p>
            </div>
          )}
        </div>

        <div className="button-container">
          <button
            onClick={handleProfile}
            className="profile-button"
          >
            Edit Profile
          </button>
        </div>
      </div>
    </div>
  );
}